<template>
  <multipane-resizer>
    <div
      class="rounded flex-shrink-0 w-16 bg-gray-40 pointer-events-none"
      style="height: 2px"
    ></div>
  </multipane-resizer>
</template>

<script>
import { MultipaneResizer } from 'vue-multipane'

export default {
  name: 'TimetableSplitViewHandleBar',

  components: {
    MultipaneResizer
  }
}
</script>

<style lang="postcss">
.multipane.splitview.layout-h .multipane-resizer {
  margin: 0;
  top: 0;
  height: 12px;
  width: 100%;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  background: theme('colors.gray.10');
  border-top: 1px solid theme('colors.gray.20');
}
</style>
